<template>
  <div>
    <div class="add_godds_top">
      <el-steps :active="1" :space="246" align-center>
        <el-step title="选择商品分类"></el-step>
        <el-step title="填写商品信息"></el-step>
      </el-steps>
    </div>
    <div style="display:flex;width:1200px">
    <div class="add_goods_cont">
      <div class="cont_left">
        <div class="cont_left_text" @click="succ()">
          <i class="iconfont icon-icon_favorite" style="font-size:18px"></i> 选择分类
          <div class="cont_left_icon"></div>
        </div>
      </div>
      <div class="cont_right">
        <div class="cont_right_opt">
          <!-- 您最近使用的商品分类:
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select> -->
        </div>

        <div class="brand">
          <div class="brand1">
            <div class="brand1_title">选择一级分类</div>
            <div class="brand1_list">
              <ul>
                <li
                  :class=" item.id ==  f_id2 ? 'li_cli' : ''"
                  v-for="item in brands"
                  :key="item.id"
                  v-show="item.f_id == 0"
                  @click="list1(item.id,item.cate_name)"
                  class="brand1_list_li"
                >
                  <span>{{item.cate_name}}</span>
                  <span>
                    <i class="iconfont icon-iconfonticonfonti2copycopy"></i>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="brand1">
            <div class="brand1_title">选择二级分类</div>
            <div class="brand1_list">
              <ul>
                <li
                  :class=" item.id ==  f_id3 ? 'li_cli' : ''"
                  v-for="item in brands"
                  :key="item.id"
                  v-show="item.f_id == f_id2"
                  @click="list2(item.id,item.cate_name)"
                >
                  <span>{{item.cate_name}}</span>
                  <span>
                    <i class="iconfont icon-iconfonticonfonti2copycopy"></i>
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div class="brand1">
            <div class="brand1_title">选择三级分类</div>
            <div class="brand1_list">
              <ul>
                <li
                  :class=" item.id ==  f_id4 ? 'li_cli' : ''"
                  v-for="item in brands"
                  :key="item.id"
                  v-show="item.f_id == f_id3"
                  @click="list3(item.id,item.cate_name)"
                >
                  <span>{{item.cate_name}}</span>
                  <span>
                    <i class="iconfont icon-iconfonticonfonti2copycopy"></i>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="botm"></div>
        <div class="btn">
          <el-button @click="next" type="primary">下一步,填写商品信息</el-button>
        </div>
      </div>
    </div>
    <div class="other_add">
      <div class="list">
        <el-divider>
          <!-- <i class="el-icon-s-tools"></i> -->
          <el-tooltip class="item" effect="light" :content="type1_msg" placement="top">
            <i class="el-icon-question" style="color:#f99b0afc;font-size:12px;">批量导入</i>
          </el-tooltip>
        </el-divider>
        <el-upload
          style="margin-right:10px"
          class="upload-demo"
          action
          :disabled="type1_status"
          :auto-upload="false"
          :limit="1"
          :on-change="handleRemove1"
        >
          <el-button plain>excel批量导入</el-button>
        </el-upload>
        <div @click="temp"><i class="el-icon-download downloadmod">点击下载模板</i></div>
        <div v-if="type2_status">
          <el-divider>
              <span style="color:#f99b0afc;font-size:12px;">智能导入</span>
          </el-divider>
          <el-button plain><router-link to="/shop/addmart" style="text-decoration: none;color: #606266;">一键智能导入</router-link></el-button>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
export default {


  data() {
    return {
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      brands: [],
      f_id2: null,
      f_id3: null,
      f_id4: null,
      name1: null,
      name2: null,
      name3: null,
      value: "",
      token: this.$cookies.get("shop_token"),
      username: this.$cookies.get("shop_username"),
      type1_msg: '批量导入每个店铺免费额度1000件商品！',
      //type2_msg: '智能导入每个店铺免费额度10件商品',
      type1_status:false,
      type2_status:false,
    };
  },
  created() {
    this.$store.state.shop_top = 1;
    this.$store.state.shop_left = "添加商品";
    //   this.$alerts.success('111',this.$message)
    this.viewNum();
    this.axios
      .get(this.$store.state.serve + "shop/get_category", {
        params: {
          token: this.token
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          this.brands = res.data.data;
        }
      });
  },
  methods: {
    viewNum(){
       this.axios
      .get(this.$store.state.serve + "shop/productNumber", {
        params: {
          token: this.token,
          username: this.username
        }
      })
      .then(res => {
        if (res.data.status == "success") {
          var data = res.data.data;
          if(data.p_num1 <=0){
            this.type1_msg = '免费额度已用完，如果需要获取更多额度，请咨询客服电话400-821-3401或13311688691开通更多额度';
            this.type1_status = true;
          }
          if(data.p_num2 > 0){
            //this.type2_msg = '免费额度已用完，如果需要获取更多额度，请咨询客服电话400-821-3401或13311688691开通更多额度';
            this.type2_status = true;
          }else{
            this.type2_status = false;
          }
        }
      });
    },
    next() {
      if (this.name3 != null) {
        this.$router.push({
          name: "shop.addgoodss",
          params: {
            name1: this.name1,
            name2: this.name2,
            name3: this.name3,
            f_id2: this.f_id2,
            f_id3: this.f_id3,
            f_id4: this.f_id4
          }
        });
      } else {
        this.$alerts.error("请选择分类", this.$message);
      }
    },
    joinMart(){
       this.$router.push({
          name: "shop.addmart"
       }) 
    },
    temp() {
      window.location.href =
        this.$store.state.serve +
        "/shop/downloadTemplate?token=" +
        this.token;
    },
     handleRemove1(file, fileList) {
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      let formData = new FormData();
      formData.append("username", this.$cookies.get("shop_username"));
      formData.append("token", this.$cookies.get("shop_token"));
      formData.append("file", file.raw);
      this.axios
        .post(this.$store.state.serve + "/shop/uploadExcels", formData, config)
        .then(res => {
          if (res.data.status == "success") {
            this.$notify({
              title: "导入成功",
              message: res.data.msg,
              type: "success",
              duration: 0
            });
          } else if (res.data.status == "error") {
            this.$notify.error({
              title: "导入失败",
              message: res.data.msg
            });
          }
        });
    },
    list1(id, name) {
      this.f_id2 = id;
      this.f_id3 = null;
      this.name1 = name;
    },
    list2(id, name) {
      this.f_id3 = id;
      this.name2 = name;
    },
    list3(id, name) {
      this.name3 = name;
      this.f_id4 = id;
    }
  }
};
</script>
<style lang='scss'>
.add_godds_top {
  width: 500px;
  margin: 0 auto;
  .is-text {
    width: 36px;
    height: 36px;
  }
  .el-step__line {
    position: absolute !important;
    top: 15px !important;
  }
}
.add_goods_cont {
  margin-top: 33px;
  width: 100%;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(221, 221, 221, 1);
  margin-bottom: 86px;
  display: flex;
  .cont_left {
    width: 182px;
    //  height: 100%;
    background: rgba(238, 238, 238, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
    position: relative;
    .cont_left_text {
      width: 100%;
      height: 54px;
      background: rgba(166, 182, 193, 1);
      position: absolute;
      left: 0;
      top: 80px;
      font-size: 18px;
      font-family: "Microsoft YaHei";
      text-align: center;
      line-height: 54px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      .cont_left_icon {
        width: 0;
        height: 0;
        border-left: 39px solid #a6b6c1;
        border-bottom: 39px solid transparent;
        transform: rotate(135deg);
        position: absolute;
        right: -19px;
        top: 8px;
      }
    }
  }
  .cont_right {
    width: 80%;
    height: 100%;
    .cont_right_opt {
      width: 400px;
      margin: 100px 100px 50px 200px;
      font-size: 14px;
      font-family: "Microsoft YaHei";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
    }
    .brand {
      width: 100%;
      display: flex;
      justify-content: space-around;
      .brand1 {
        .brand1_title {
          width: 212px;
          height: 47px;
          background: rgba(245, 250, 249, 1);
          border: 1px solid rgba(221, 221, 221, 1);
          border-top-left-radius: 8px;
          border-top-right-radius: 8px;
          font-size: 16px;
          text-align: center;
          line-height: 47px;
          font-family: "Microsoft YaHei";
          font-weight: 300;
          color: rgba(102, 102, 102, 1);
        }
        .brand1_list {
          border-left: 1px solid rgba(221, 221, 221, 1);
          border-right: 1px solid rgba(221, 221, 221, 1);
          background: rgba(255, 255, 255, 1);
          li {
            width: 192px;
            border-bottom: 1px solid rgba(221, 221, 221, 1);
            // height: 38px;
            font-size: 14px;
            line-height: 38px;
            font-family: "Microsoft YaHei";
            font-weight: 300;
            color: rgba(153, 153, 153, 1);
            display: flex;
            justify-content: space-between;
            padding-left: 10px;
            padding-right: 10px;
           cursor: pointer;
          }
          li:hover{
            color: rgba(0, 153, 255, 1);
          }
          .li_cli {
            color: rgba(0, 153, 255, 1);
          }
        }
      }
    }
    .botm {
      width: 100%;
      height: 1px;
      background: rgba(221, 221, 221, 1);
      margin: 50px 0 60px 0;
    }
    .btn {
      width: 150px;
      margin: 0 auto;
      margin-bottom: 300px;
    }
  }
}
.other_add{
    border: 1px dashed #dad7d7;
    width: 15%;
    height: 500px;
    margin: 34px 9px;
   .list{
     margin:0 auto;
     text-align: center;
     .el-divider__text {
       background-color: #f5f5f5;padding: 0 5px;}
     .downloadmod{
       cursor:pointer;
       text-decoration: underline;
     }
     button{
       margin:10px 0;
     }
   } 
}
</style>